import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  TextField,
  Typography,
  FormHelperText,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Switch,
  Button,
  IconButton,
  Box,
  Tooltip,
  Autocomplete,
  Modal,
  Paper,
} from "@mui/material";
import { isFieldVisible, validateForm } from "./formUtils";
import formConfig from "./formConfig";
import CustomIOSSwitch from "../../../../../services/iosSwitch";
const InstrumentTerms = ({
  formData,
  setFormData,
  errors,
  setErrors,
  handleChange,
  formMode,
  selectedTradeRFQ,
}) => {
  const handleCheckboxChange = (e) => {
    handleChange(e); // Use parent's handleChange to update formData
    // const updatedErrors = validateForm(formData, formData.instrument);
    // setErrors(updatedErrors); // Update errors after state change
  };

  const handleTextChange = (e) => {
    handleChange(e); // Use parent's handleChange
  };

  const handleNumberChange = (e) => {
    const { name, value } = e.target;

    // **ALLOW TYPING** - Don't modify during typing
    // Only validate AFTER the user finishes typing (onBlur) or on valid input
    handleChange(e);

    // **IMMEDIATE VALIDATION** - Ensure no negatives in state
    if (value && parseFloat(value) < 0) {
      // Force to 0 only if negative
      const correctedValue = 0;
      handleChange({
        target: {
          name,
          value: correctedValue
        }
      });
    }
  };
  const handleNumberBlur = (e) => {
    const { name, value } = e.target;
    let finalValue = value;

    if (value === "" || value === null) {
      finalValue = "";
    } else {
      const num = parseFloat(value);
      if (isNaN(num)) {
        finalValue = "";
      } else {
        finalValue = Math.max(0, num).toString(); // **FORCE >= 0**
      }
    }

    handleChange({
      target: {
        name,
        value: finalValue
      }
    });
  };


  return (
    <div className="tab-pane active">
      <div className="row g-3">
        {isFieldVisible(
          "advisingConfirmingBankRequired",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-3">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.advisingConfirmingBankRequired}
              >
                <Typography variant="body2">
                  Advising / Confirming Bank Required?
                </Typography>
                <FormControlLabel
                  control={
                    <CustomIOSSwitch
                      name="advisingConfirmingBankRequired"
                      checked={!!formData.advisingConfirmingBankRequired}
                      onChange={handleCheckboxChange}

                      inputProps={{
                        "aria-label": "Advising/Confirming Bank Required",
                      }}
                      sx={{ m: 1 }}
                    />
                    // <Switch
                    //   name="advisingConfirmingBankRequired"
                    //   checked={!!formData.advisingConfirmingBankRequired}
                    //   onChange={handleCheckboxChange}
                    //   size="small"
                    //   inputProps={{
                    //     "aria-label": "Advising/Confirming Bank Required",
                    //   }}
                    //   sx={{
                    //     "& .MuiSwitch-switchBase.Mui-checked": {
                    //       color: "#de6b14",
                    //     },
                    //     "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                    //       {
                    //         backgroundColor: "#de6b14",
                    //       },
                    //   }}
                    // />
                  }
                  label={formData.advisingConfirmingBankRequired ? "Yes" : "No"}
                />
              </FormControl>
            </div>
          )}

        {isFieldVisible(
          "confirmationRequired",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-3">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.confirmationRequired}
              >
                <Typography variant="body2">Confirmation Required?</Typography>
                <FormControlLabel
                  control={
                    <CustomIOSSwitch
                      name="confirmationRequired"
                      checked={!!formData.confirmationRequired}
                      onChange={handleCheckboxChange}
                      size="small"
                      inputProps={{ "aria-label": "Confirmation Required" }}
                      sx={{ m: 1 }}
                    />
                    // <Switch
                    //   name="confirmationRequired"
                    //   checked={!!formData.confirmationRequired}
                    //   onChange={handleCheckboxChange}
                    //   size="small"
                    //   inputProps={{ "aria-label": "Confirmation Required" }}
                    //   sx={{
                    //     "& .MuiSwitch-switchBase.Mui-checked": {
                    //       color: "#de6b14",
                    //     },
                    //     "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                    //     {
                    //       backgroundColor: "#de6b14",
                    //     },
                    //   }}
                    // />
                  }
                  label={formData.confirmationRequired ? "Yes" : "No"}
                />
              </FormControl>
            </div>
          )}
        {isFieldVisible(
          "partialShipmentAllowed",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-3">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.partialShipmentAllowed}
              >
                <Typography variant="body2">Partial Shipment Allowed?</Typography>
                <FormControlLabel
                  control={
                    <CustomIOSSwitch
                      name="partialShipmentAllowed"
                      checked={!!formData.partialShipmentAllowed}
                      onChange={handleCheckboxChange}
                      size="small"
                      inputProps={{ "aria-label": "Partial Shipment Allowed" }}
                      sx={{ m: 1 }}
                    />
                    // <Switch
                    //   name="partialShipmentAllowed"
                    //   checked={!!formData.partialShipmentAllowed}
                    //   onChange={handleCheckboxChange}
                    //   size="small"
                    //   inputProps={{ "aria-label": "Partial Shipment Allowed" }}
                    //   sx={{
                    //     "& .MuiSwitch-switchBase.Mui-checked": {
                    //       color: "#de6b14",
                    //     },
                    //     "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                    //     {
                    //       backgroundColor: "#de6b14",
                    //     },
                    //   }}
                    // />
                  }
                  label={formData.partialShipmentAllowed ? "Yes" : "No"}
                />
              </FormControl>
            </div>
          )}
        {isFieldVisible(
          "transshipmentAllowed",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-3">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.transshipmentAllowed}
              >
                <Typography variant="body2">Transshipment Allowed?</Typography>
                <FormControlLabel
                  control={
                    <CustomIOSSwitch
                      name="transshipmentAllowed"
                      checked={!!formData.transshipmentAllowed}
                      onChange={handleChange}
                      size="small"
                      inputProps={{ "aria-label": "Transshipment Allowed" }}
                      sx={{ m: 1 }}
                    />
                    // <Switch
                    //   name="transshipmentAllowed"
                    //   checked={!!formData.transshipmentAllowed}
                    //   onChange={handleChange}
                    //   size="small"
                    //   inputProps={{ "aria-label": "Transshipment Allowed" }}
                    //   sx={{
                    //     "& .MuiSwitch-switchBase.Mui-checked": {
                    //       color: "#de6b14",
                    //     },
                    //     "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                    //     {
                    //       backgroundColor: "#de6b14",
                    //     },
                    //   }}
                    // />
                  }
                  label={formData.transshipmentAllowed ? "Yes" : "No"}
                />
              </FormControl>
            </div>
          )}
        {isFieldVisible("instrumentTerms", formData.instrument, formConfig) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              disabled={formMode === "view"}
              error={!!errors.instrumentTerms}
            >
              <Typography variant="body2">Revolving Terms</Typography>

              <TextField
                name="instrumentTerms"
                value={formData.instrumentTerms}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder="Leave blank for open bidding"
                inputProps={{ "aria-label": "Instrument Terms" }}
                disabled={formMode === "view"}
              />
              {errors.instrumentTerms && (
                <FormHelperText>{errors.instrumentTerms}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible(
          "confirmationCharges",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.confirmationCharges}
              >
                <Typography variant="body2">Confirmation Charges</Typography>
                <TextField
                  name="confirmationCharges"
                  type="number"
                  step="0.01"
                  min="0"
                  inputMode="decimal"
                  value={formData.confirmationCharges || ""}
                  onChange={handleNumberChange}
                  onBlur={handleNumberBlur}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  placeholder="e.g., 1.0%"
                  inputProps={{ "aria-label": "Confirmation Charges" }}
                  disabled={formMode === "view"}
                />
                {errors.confirmationCharges && (
                  <FormHelperText>{errors.confirmationCharges}</FormHelperText>
                )}
              </FormControl>
            </div>
          )}
        {isFieldVisible("issuanceCharges", formData.instrument, formConfig) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              disabled={formMode === "view"}
              error={!!errors.issuanceCharges}
            >
              <Typography variant="body2">Issuance Charges</Typography>
              <TextField
                type="number"
                step="0.01"
                min="0"
                inputMode="decimal"
                name="issuanceCharges"
                value={formData.issuanceCharges || ""}
                onChange={handleNumberChange}
                onBlur={handleNumberBlur}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder="e.g., 0.5% (min $250)"
                inputProps={{ "aria-label": "Issuance Charges" }}
                disabled={formMode === "view"}
              />
              {errors.issuanceCharges && (
                <FormHelperText>{errors.issuanceCharges}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible(
          "interestRateMargin",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.interestRateMargin}
              >
                <Typography variant="body2">Interest Rate Margin (%)</Typography>
                <TextField
                  type="number"
                  step="0.01"
                  min="0"
                  inputMode="decimal"
                  name="interestRateMargin"
                  value={formData.interestRateMargin || ""}
                  onChange={handleNumberChange}
                  onBlur={handleNumberBlur}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  placeholder="e.g., 2.5%"
                  inputProps={{ "aria-label": "Interest Rate Margin" }}
                  disabled={formMode === "view"}
                />
                {errors.interestRateMargin && (
                  <FormHelperText>{errors.interestRateMargin}</FormHelperText>
                )}
              </FormControl>
            </div>
          )}
        {isFieldVisible("tenorOffered", formData.instrument, formConfig) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              disabled={formMode === "view"}
              error={!!errors.tenorOffered}
            >
              <Typography variant="body2">
                Tenor Offered (Days/Months)
              </Typography>
              <TextField
                name="tenorOffered"
                value={formData.tenorOffered || ""}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder="e.g., 120 Days"
                inputProps={{ "aria-label": "Tenor Offered" }}
                disabled={formMode === "view"}
              />
              {errors.tenorOffered && (
                <FormHelperText>{errors.tenorOffered}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible("GuaranteeType", formData.instrument, formConfig) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              disabled={formMode === "view"}
              error={!!errors.GuaranteeType}
            >
              <Typography variant="body2">Guarantee Type</Typography>
              <TextField
                name="GuaranteeType"
                value={formData.GuaranteeType || ""}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder=""
                inputProps={{ "aria-label": "Guarantee Type" }}
                disabled={formMode === "view"}
              />
              {errors.GuaranteeType && (
                <FormHelperText>{errors.GuaranteeType}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible("GuaranteeAmount", formData.instrument, formConfig) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              disabled={formMode === "view"}
              error={!!errors.GuaranteeAmount}
            >
              <Typography variant="body2">Guarantee Amount</Typography>
              <TextField
                name="GuaranteeAmount"
                type="number"
                min="0"
                step="any"
                value={formData.GuaranteeAmount || ""}
                onChange={handleNumberChange}
                onBlur={handleNumberBlur}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder=""
                inputProps={{ "aria-label": "Guarantee Amount" }}
                disabled={formMode === "view"}
              />
              {errors.GuaranteeAmount && (
                <FormHelperText>{errors.GuaranteeAmount}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible(
          "GuaranteeValidityDate",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.GuaranteeValidityDate}
              >
                <Typography variant="body2">Guarantee Validity Date</Typography>
                <TextField
                  name="GuaranteeValidityDate"
                  type="date"
                  value={formData.GuaranteeValidityDate || ""}
                  onChange={handleChange}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  placeholder=""
                  inputProps={{ "aria-label": "Guarantee Validity Date" }}
                  disabled={formMode === "view"}
                />
                {errors.GuaranteeValidityDate && (
                  <FormHelperText>{errors.GuaranteeValidityDate}</FormHelperText>
                )}
              </FormControl>
            </div>
          )}
        {isFieldVisible("ClaimExpiryDate", formData.instrument, formConfig) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              disabled={formMode === "view"}
              error={!!errors.ClaimExpiryDate}
            >
              <Typography variant="body2">Claim Expiry Date</Typography>
              <TextField
                name="ClaimExpiryDate"
                type="date"
                value={formData.ClaimExpiryDate || ""}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder=""
                inputProps={{ "aria-label": "Claim Expiry Date" }}
                disabled={formMode === "view"}
              />
              {errors.ClaimExpiryDate && (
                <FormHelperText>{errors.ClaimExpiryDate}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible(
          "ClaimProcessInstructions",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.ClaimProcessInstructions}
              >
                <Typography variant="body2">
                  Claim Process Instructions
                </Typography>
                <TextField
                  name="ClaimProcessInstructions"
                  value={formData.ClaimProcessInstructions || ""}
                  onChange={handleChange}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  placeholder=""
                  inputProps={{ "aria-label": "Claim Process Instructions" }}
                  disabled={formMode === "view"}
                />
                {errors.ClaimProcessInstructions && (
                  <FormHelperText>
                    {errors.ClaimProcessInstructions}
                  </FormHelperText>
                )}
              </FormControl>
            </div>
          )}
        {isFieldVisible(
          "CounterGuarantee",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.CounterGuarantee}
              >
                <Typography variant="body2">Counter Guarantee</Typography>
                <TextField
                  name="CounterGuarantee"
                  value={formData.CounterGuarantee || ""}
                  onChange={handleChange}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  placeholder=""
                  inputProps={{ "aria-label": "Counter Guarantee" }}
                  disabled={formMode === "view"}
                />
                {errors.CounterGuarantee && (
                  <FormHelperText>{errors.CounterGuarantee}</FormHelperText>
                )}
              </FormControl>
            </div>
          )}
        {isFieldVisible(
          "UnderlyingContractRef",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.UnderlyingContractRef}
              >
                <Typography variant="body2">Underlying Contract Ref</Typography>
                <TextField
                  name="UnderlyingContractRef"
                  value={formData.UnderlyingContractRef || ""}
                  onChange={handleChange}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  placeholder=""
                  inputProps={{ "aria-label": "Underlying Contract Ref" }}
                  disabled={formMode === "view"}
                />
                {errors.UnderlyingContractRef && (
                  <FormHelperText>{errors.UnderlyingContractRef}</FormHelperText>
                )}
              </FormControl>
            </div>
          )}
        {isFieldVisible(
          "TriggerConditions",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.TriggerConditions}
              >
                <Typography variant="body2">Trigger Conditions</Typography>
                <TextField
                  name="TriggerConditions"
                  value={formData.TriggerConditions || ""}
                  onChange={handleChange}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  placeholder=""
                  inputProps={{ "aria-label": "Trigger Conditions" }}
                  disabled={formMode === "view"}
                />
                {errors.TriggerConditions && (
                  <FormHelperText>{errors.TriggerConditions}</FormHelperText>
                )}
              </FormControl>
            </div>
          )}
        {isFieldVisible("ExpiryEvent", formData.instrument, formConfig) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              disabled={formMode === "view"}
              error={!!errors.ExpiryEvent}
            >
              <Typography variant="body2">Expiry Event</Typography>
              <TextField
                name="ExpiryEvent"
                value={formData.ExpiryEvent || ""}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder=""
                inputProps={{ "aria-label": "Expiry Event" }}
                disabled={formMode === "view"}
              />
              {errors.ExpiryEvent && (
                <FormHelperText>{errors.ExpiryEvent}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible(
          "CollectionMethod",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.CollectionMethod}
              >
                <Typography variant="body2">Collection Method</Typography>
                <TextField
                  name="CollectionMethod"
                  value={formData.CollectionMethod || ""}
                  onChange={handleChange}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  placeholder=""
                  inputProps={{ "aria-label": "Collection Method" }}
                  disabled={formMode === "view"}
                />
                {errors.CollectionMethod && (
                  <FormHelperText>{errors.CollectionMethod}</FormHelperText>
                )}
              </FormControl>
            </div>
          )}
        {isFieldVisible("AcceptanceTerms", formData.instrument, formConfig) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              disabled={formMode === "view"}
              error={!!errors.AcceptanceTerms}
            >
              <Typography variant="body2">Acceptance Terms</Typography>
              <TextField
                name="AcceptanceTerms"
                value={formData.AcceptanceTerms || ""}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder=""
                inputProps={{ "aria-label": "Acceptance Terms" }}
                disabled={formMode === "view"}
              />
              {errors.AcceptanceTerms && (
                <FormHelperText>{errors.AcceptanceTerms}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible("PaymentDueDate", formData.instrument, formConfig) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              disabled={formMode === "view"}
              error={!!errors.PaymentDueDate}
            >
              <Typography variant="body2">Payment Due Date</Typography>
              <TextField
                name="PaymentDueDate"
                type="date"
                value={formData.PaymentDueDate || ""}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder=""
                inputProps={{ "aria-label": "Payment Due Date" }}
                disabled={formMode === "view"}
              />
              {errors.PaymentDueDate && (
                <FormHelperText>{errors.PaymentDueDate}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible(
          "InsuranceCoveragePercent",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.InsuranceCoveragePercent}
              >
                <Typography variant="body2">Insurance Coverage %</Typography>
                <TextField
                  name="InsuranceCoveragePercent"
                  type="number"
                  min="0"
                  step="any"
                  value={formData.InsuranceCoveragePercent || ""}
                  onChange={handleNumberChange}
                  onBlur={handleNumberBlur}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  placeholder=""
                  inputProps={{ "aria-label": "Insurance Coverage %" }}
                  disabled={formMode === "view"}
                />
                {errors.InsuranceCoveragePercent && (
                  <FormHelperText>
                    {errors.InsuranceCoveragePercent}
                  </FormHelperText>
                )}
              </FormControl>
            </div>
          )}
        {isFieldVisible(
          "PremiumAmountTerms",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.PremiumAmountTerms}
              >
                <Typography variant="body2">Premium Amount Terms</Typography>
                <TextField
                  name="PremiumAmountTerms"
                  value={formData.PremiumAmountTerms || ""}
                  onChange={handleChange}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  placeholder=""
                  inputProps={{ "aria-label": "Premium Amount Terms" }}
                  disabled={formMode === "view"}
                />
                {errors.PremiumAmountTerms && (
                  <FormHelperText>{errors.PremiumAmountTerms}</FormHelperText>
                )}
              </FormControl>
            </div>
          )}
        {isFieldVisible("PolicyPeriod", formData.instrument, formConfig) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              disabled={formMode === "view"}
              error={!!errors.PolicyPeriod}
            >
              <Typography variant="body2">Policy Period</Typography>
              <TextField
                name="PolicyPeriod"
                value={formData.PolicyPeriod || ""}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder=""
                inputProps={{ "aria-label": "Policy Period" }}
                disabled={formMode === "view"}
              />
              {errors.PolicyPeriod && (
                <FormHelperText>{errors.PolicyPeriod}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible(
          "EscrowAgentOrBank",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.EscrowAgentOrBank}
              >
                <Typography variant="body2">Escrow Agent/ Bank</Typography>
                <TextField
                  name="EscrowAgentOrBank"
                  value={formData.EscrowAgentOrBank || ""}
                  onChange={handleChange}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  placeholder=""
                  inputProps={{ "aria-label": "Escrow Agent/ Bank" }}
                  disabled={formMode === "view"}
                />
                {errors.EscrowAgentOrBank && (
                  <FormHelperText>{errors.EscrowAgentOrBank}</FormHelperText>
                )}
              </FormControl>
            </div>
          )}
        {isFieldVisible("EscrowAmount", formData.instrument, formConfig) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              disabled={formMode === "view"}
              error={!!errors.EscrowAmount}
            >
              <Typography variant="body2">Escrow Amount</Typography>
              <TextField
                name="EscrowAmount"
                type="number"
                min="0"
                step="any"
                value={formData.EscrowAmount || ""}
                onChange={handleNumberChange}
                onBlur={handleNumberBlur}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder=""
                inputProps={{ "aria-label": "Escrow Amount" }}
                disabled={formMode === "view"}
              />
              {errors.EscrowAmount && (
                <FormHelperText>{errors.EscrowAmount}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible(
          "ReleaseConditions",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.ReleaseConditions}
              >
                <Typography variant="body2">Release Conditions</Typography>
                <TextField
                  name="ReleaseConditions"
                  value={formData.ReleaseConditions || ""}
                  onChange={handleChange}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  placeholder=""
                  inputProps={{ "aria-label": "Release Conditions" }}
                  disabled={formMode === "view"}
                />
                {errors.ReleaseConditions && (
                  <FormHelperText>{errors.ReleaseConditions}</FormHelperText>
                )}
              </FormControl>
            </div>
          )}
        {isFieldVisible("CreditLimit", formData.instrument, formConfig) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              disabled={formMode === "view"}
              error={!!errors.CreditLimit}
            >
              <Typography variant="body2">Credit Limit</Typography>
              <TextField
                name="CreditLimit"
                value={formData.CreditLimit || ""}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder=""
                inputProps={{ "aria-label": "Credit Limit" }}
                disabled={formMode === "view"}
              />
              {errors.CreditLimit && (
                <FormHelperText>{errors.CreditLimit}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible(
          "LatePaymentPenalty",
          formData.instrument,
          formConfig
        ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.LatePaymentPenalty}
              >
                <Typography variant="body2">Late Payment Penalty</Typography>
                <TextField
                  name="LatePaymentPenalty"
                  value={formData.LatePaymentPenalty || ""}
                  onChange={handleChange}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  placeholder=""
                  inputProps={{ "aria-label": "Late Payment Penalty" }}
                  disabled={formMode === "view"}
                />
                {errors.LatePaymentPenalty && (
                  <FormHelperText>{errors.LatePaymentPenalty}</FormHelperText>
                )}
              </FormControl>
            </div>
          )}
      </div>
    </div>
  );
};

export default InstrumentTerms;
